// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"c2e957a3","651":"5af8b33a","830":"0c8e0c8d","886":"06884019","919":"9d29c454","987":"0c347be8"}[chunkId] + ".chunk.js";
};